import fetch from '@ixigo/fetch';

export interface IxigoMoneyWallet {
	balance: number;
}

export function fetchWalletDetails() {
	return fetch
		.get('api/v3/ixigo-money/wallet')
		.json<{ data?: IxigoMoneyWallet }>();
}
